import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GridModule, PDFModule, ExcelModule } from '@progress/kendo-angular-grid';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DialogModule, WindowModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { MaterialListModule } from '../material-list/material-list.module';
//import { LayoutModule } from '@progress/kendo-angular-layout';
import { PopupModule } from '@progress/kendo-angular-popup';
import { NgScrollbarModule } from 'ngx-scrollbar';

import {FormsModule,ReactiveFormsModule} from '@angular/forms';
import { NbCardModule, NbIconModule, NbInputModule, NbTreeGridModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';

import { ThemeModule } from '../../@theme/theme.module';
import { CategoriesService } from '../tables/kendotable/northwind.service';

import { CalendarModule } from 'primeng/calendar';
import {ToastModule} from 'primeng/toast';
import {RippleModule} from 'primeng/ripple';
import {ButtonModule} from 'primeng/button';
import {TableModule} from 'primeng/table';
import {ToolbarModule} from 'primeng/toolbar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

// import { FsIconComponent } from './tree-grid/tree-grid.component';
// import { TablecrudComponent } from './tablecrud/tablecrud.component';
// import { ProductService } from './product.service';

import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import {SliderModule} from 'primeng/slider';
import {MultiSelectModule} from 'primeng/multiselect';

import {ContextMenuModule} from 'primeng/contextmenu';
import {InputTextModule} from 'primeng/inputtext';
import {InputNumberModule} from 'primeng/inputnumber';
import {FileUploadModule} from 'primeng/fileupload';
import {RadioButtonModule} from 'primeng/radiobutton';
import {DropdownModule} from 'primeng/dropdown';
import {CheckboxModule} from 'primeng/checkbox';

import { InputTextareaModule } from 'primeng/inputtextarea';
import {RatingModule} from 'primeng/rating';

// import { KendotableComponent } from './kendotable/kendotable.component';

import { DialogsModule } from '@progress/kendo-angular-dialog';
import { IntlModule } from '@progress/kendo-angular-intl';
import { EditorModule } from '@progress/kendo-angular-editor';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { LabelModule } from '@progress/kendo-angular-label';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { SortDescriptor } from '@progress/kendo-data-query';
import { FileUploadComponent } from './file-upload/file-upload.component';

@NgModule({
  imports: [
    CommonModule,
    GridModule,
    ButtonsModule,
    PDFModule,
    ExcelModule,
    DialogModule,
    ReactiveFormsModule,
    DropDownsModule,
    DateInputsModule,
    MaterialListModule,
    WindowModule,
    //LayoutModule
    MatSelectModule,
    MatFormFieldModule,

    NbCardModule,
    NbTreeGridModule,
    NbIconModule,
    NbInputModule,
    ThemeModule,
    Ng2SmartTableModule,

    FormsModule,
    CalendarModule,
    TableModule,
    ToastModule,
    RippleModule,
    ButtonModule,
    ToolbarModule,
    DialogModule,
    ConfirmDialogModule,
    ToastModule,
    CalendarModule,
    SliderModule,
    MultiSelectModule,
    ContextMenuModule,
    InputTextModule,
    InputNumberModule,
    FileUploadModule,
    RadioButtonModule,
    InputTextareaModule,
    RatingModule,
    DropdownModule,
    CheckboxModule,

    NgScrollbarModule,

    GridModule,
    DropDownsModule,
    DialogsModule,
    ButtonsModule,
    DateInputsModule,
    IntlModule,
    EditorModule,
    ExcelExportModule,
    IndicatorsModule,
    InputsModule,
    LabelModule,
    ReactiveFormsModule,
    ListViewModule
  ],
  declarations: [FileUploadComponent],
  exports: [
    CommonModule,
    FormsModule,
    GridModule,
    ButtonsModule,
    PDFModule,
    ExcelModule,
    DialogModule,
    ReactiveFormsModule,
    DropDownsModule,
    DateInputsModule,
    MaterialListModule,
    WindowModule,
    //LayoutModule,
    PopupModule,
    NgScrollbarModule,
    InputsModule
  ]
})
export class SharedModule {}
